import { navigateToCheckout } from './navigate-to-checkout/navigate-to-checkout';
import { openPopup } from './open-popup';
import { submitForm } from './submit-form';
export const FORM_ASYNC_ACTIONS = {
    submitForm,
    navigateToCheckout,
    openPopup
};

//# sourceMappingURL=index.js.map